import React, { Component } from 'react';
import ViewButton from './_ViewButton'

const styles = {
  ulStyle: {
    boxSizing: 'border-box',
    listStyleType: 'none',
    margin: '0',
    padding: '0',
    paddingLeft: '12px',
    overflow: 'hidden',
    top: '0',
    width: '100%',
    // border: '1px solid grey',
    zIndex: '60',
    backgroundColor: 'white',
  },
  liLeftStyle: {
    float: 'left'
  },
  // liRightStyle: {
  //   float: 'right'
  // }
}

class _EmbedHeaderComponent extends Component {
  constructor() {
    super()
    this.state = {
      hovered: ""
    }
  }
  render() {
    const { ulStyle, liLeftStyle } = styles;
    return (
      <div>
        <ul style={ulStyle}>
          <li style={liLeftStyle}>
            <ViewButton
              onClick={() => this.props.buttonClick("data")}
              active={this.props.active === "data"}>Data</ViewButton>
          </li>
          <li style={liLeftStyle}>
            <ViewButton
              onClick={() => this.props.buttonClick("html")}
              active={this.props.active === "html"}>HTML</ViewButton>
          </li>
          <li style={liLeftStyle}>
            <ViewButton
              onClick={() => this.props.buttonClick("css")}
              active={this.props.active === "css"}>CSS</ViewButton>
          </li>
          <li style={liLeftStyle}>
            <ViewButton
              onClick={() => this.props.buttonClick("javascript")}
              active={this.props.active === "javascript"}>Javascript</ViewButton>
          </li>
          <li style={liLeftStyle}>
            <ViewButton
              onClick={() => this.props.buttonClick("settings")}
              active={this.props.active === "settings"}>Libs</ViewButton>
          </li>
        </ul>
      </div>
    );
  }
}

export default _EmbedHeaderComponent;



// WEBPACK FOOTER //
// ./src/_Tabs.js